"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const SaveOutlined_1 = __importDefault(require("@mui/icons-material/SaveOutlined"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const SaveField = ({ attributes, forceStatic, callbacks, editable, SHOW_ALL, fieldActive, txn, focusField, }) => {
    const { classes } = useStyles();
    return (<styles_1.RegListItem {...attributes} tabIndex={null} onClick={forceStatic ? null : () => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'save', txn); }} className={(0, classnames_1.default)(classes.iconButtonColumn, forceStatic ? 'nopoint skinny' : 'skinny')}>
      {editable && SHOW_ALL &&
            <QIconButton_1.default aria-label="Save Transaction" autoFocus={fieldActive} focusRipple ref={fieldActive ?
                    (input) => {
                        focusField.current = input; // eslint-disable-line
                    } : null} disabled={forceStatic} IconComponent={SaveOutlined_1.default} IconProps={{
                    className: (0, classnames_1.default)(classes.reviewed, 'save'),
                }} size="small-target" tooltip="Save Transaction" TooltipProps={{ distance: 2 }}/>}
    </styles_1.RegListItem>);
};
exports.default = SaveField;
